import React, { useEffect, useLayoutEffect, useState, useContext, useRef, useMemo } from 'react'
import openSocket from 'socket.io-client'
//import { socket } from '../../../common/socket'
import { Button, Drawer } from '@material-ui/core'
import MenuItem from '@material-ui/core/MenuItem'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'
import BiddingItem from '../../../components/molecules/Bidding/BiddingItem'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { Pagination } from '@material-ui/lab'
import Box from '@material-ui/core/Box'
import { useHistory } from 'react-router-dom'
import CustomSelect from '../../../components/atoms/Inputs/CustomSelect'
import SecondaryButton from '../../../components/atoms/SecondaryButton'
import FavoriteCheckbox from '../../../components/atoms/FavoriteCheckbox'
import PrimaryButton from '../../../components/atoms/PrimaryButton'
import LineItemDetails from './LineItemDetails'
import Timer from '../../../common/timer'
import Popup from '../../../components/organisms/Popup'
import BidHistory from '../../../components/organisms/BidHistory'
import CurrencyConverter from '../CurrencyConverter'
import { apiCall } from '../../../common/api'
import { getProductImageAlt } from '../../../common/components'
import { lineItemBidSocketHandler } from '../../Common/socketHandler'
import ReactHtmlParser from 'react-html-parser'
// context
import CommonContext from '../../../context/common/commonContext'
import AuthContext from '../../../context/auth/authContext'
import AlertContext from '../../../context/alert/alertContext'
import Loader from '../../../components/molecules/Loader'

function TabPanel(props) {
    const { children, value, index, html, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {html ? (
                        <span
                            dangerouslySetInnerHTML={{
                                __html: html,
                            }}
                        ></span>
                    ) : (
                        <span>{children}</span>
                    )}
                </Box>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    fullList: {
        width: 'auto',
    },
}))

const normalizeLineItemKey = (key = '') =>
    String(key)
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')

const humanizeLineItemKey = (key = '') =>
    String(key)
        .trim()
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase())

const LINE_ITEM_HEADER_ALIASES = {
    brand: ['brand'],
    model: ['model'],
    generation: ['generation'],
    socket: ['socket'],
    product_name: ['product_name', 'productname'],
    memory_type: ['memory_type', 'memorytype', 'memory_t'],
    form_factor: ['form_factor', 'formfactor', 'form_fact'],
    ports: ['ports', 'port'],
    capacity: ['capacity'],
    part_number: ['part_number', 'partnumber', 'part_num', 'pn'],
    asset_type: ['asset_type', 'assettype'],
    manufacturer: ['manufacturer', 'manufactur', 'manufactu'],
    memory_speed: ['memory_speed', 'memoryspeed', 'memory_s'],
    memory_size: ['memory_size', 'memorysize', 'memory_sz'],
    memory_rank: ['memory_rank', 'memoryrank', 'memory_r'],
    category: ['category'],
    price: ['price'],
    sprice: ['sprice', 'start_price', 'startprice', 'start_pr'],
    rprice: [
        'rprice',
        'r_price',
        'reserve',
        'reserve_pr',
        'reservepr',
        'reserve_price',
        'reserveprice',
    ],
    qty: ['qty', 'quantity', 'quant'],
}

const LINE_ITEM_TABLE_COLUMNS = {
    CPU: ['brand', 'model', 'generation', 'socket'],
    GPU: ['brand', 'product_name', 'memory_type', 'form_factor', 'ports'],
    SSD: ['brand', 'capacity', 'part_number'],
    RAM: ['asset_type', 'memory_type', 'form_factor', 'manufacturer', 'part_number'],
}

const LINE_ITEM_DETAIL_COLUMNS = {
    CPU: ['brand', 'model', 'generation', 'socket'],
    GPU: ['brand', 'product_name', 'memory_type', 'form_factor', 'ports'],
    SSD: ['brand', 'capacity', 'part_number'],
    RAM: [
        'asset_type',
        'memory_type',
        'form_factor',
        'manufacturer',
        'part_number',
        'memory_speed',
        'memory_size',
        'memory_rank',
        'category',
    ],
}

const getCanonicalLineItemKey = (rawKey = '') => {
    const normalizedKey = normalizeLineItemKey(rawKey)
    for (const [canonicalKey, aliases] of Object.entries(LINE_ITEM_HEADER_ALIASES)) {
        if (aliases.includes(normalizedKey)) {
            return canonicalKey
        }
    }
    return normalizedKey
}

const isLineItemValuePresent = (value) => {
    if (value === 0 || value === '0') return true
    if (value === null || typeof value === 'undefined') return false
    if (typeof value !== 'string') return true
    const trimmedValue = value.trim()
    return trimmedValue !== '' && trimmedValue !== '-'
}

const toLineItemCellDisplayValue = (value) => {
    if (value === 0 || value === '0') return value
    if (value === null || typeof value === 'undefined') return '-'
    if (typeof value === 'string' && value.trim() === '') return '-'
    return value
}

const parseLineItemBidInteger = (value, fallback = 0) => {
    const parsed = parseFloat(
        String(value ?? '')
            .replace(/,/g, '')
            .trim(),
    )
    return Number.isNaN(parsed) ? fallback : parsed
}

const LineItemAuction = ({ images, product, downloadFile, setProduct }) => {
    const alertContext = useContext(AlertContext)
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext
    const { setAlert } = alertContext
    const { phrase, setBidHistoryValue } = useContext(CommonContext)
    const [value, setValue] = useState(0)
    const [lineItems, setLineItems] = useState([])
    const [lineItemsView, setLineItemsView] = useState([])
    const [totalProductCnt, setTotalProductCnt] = useState(0)
    const [totalPageCnt, setTotalPageCnt] = useState(0)
    const [pageDescription, setPageDescription] = useState(0)
    const [pageNum, setPageNum] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [lineItemsReady, setLineItemsReady] = useState(false)
    const [bidInstructionOpen, setBidInstructionOpen] = useState(false)
    const [bulkBidLineItems, setBulkBidLineItems] = useState([])
    const [bulkBidTable, setBulkBidTable] = useState([])
    const [bulkBidPopupOpen, setBulkBidPopupOpen] = useState(false)
    const [showDwBidStatus, setDwBidStatus] = useState(product.dwBidStatus) // download bid status link
    const [contactPopup, setContactPopup] = useState(false)
    const [productDescPopup, setProductDescPopup] = useState(false)
    const [zoomOpen, setZoomOpen] = useState(false)
    const [zoomImageIndex, setZoomImageIndex] = useState(0)
    const [isFullscreen, setIsFullscreen] = useState(false)
    const [lineItemBidInputs, setLineItemBidInputs] = useState({})
    const [lineItemCommonError, setLineItemCommonError] = useState('')
    const [isSubmittingLineItemCommonBid, setIsSubmittingLineItemCommonBid] = useState(false)
    const [currentTimeMs, setCurrentTimeMs] = useState(Date.now())
    const lineItemTemplateType = useMemo(() => {
        return String(product?.lineitem_product_type || '')
    }, [product?.lineitem_product_type])
    const startTimeMs = new Date(product?.date_added).getTime()
    const hasValidStartTime = !Number.isNaN(startTimeMs)
    const isAuctionNotStarted = hasValidStartTime && startTimeMs > currentTimeMs
    const endTimeMs = new Date(product?.date_closed).getTime()
    const hasValidEndTime = !Number.isNaN(endTimeMs)
    const isAuctionEnded = hasValidEndTime && endTimeMs < currentTimeMs
    const lineItemMinBidCount = Math.max(parseInt(product?.lineitem_min_bid_count || 0, 10) || 0, 0)

    const hasExistingLineItemBid = (item) => {
        const hasBidValue = parseInt(item?.hasBid ?? item?.companyHasBid ?? 0, 10)
        return !Number.isNaN(hasBidValue) && hasBidValue > 0
    }

    const existingLineItemBidCount = useMemo(() => {
        return lineItems.reduce((count, item) => {
            return count + (hasExistingLineItemBid(item) ? 1 : 0)
        }, 0)
    }, [lineItems])

    const remainingLineItemBidCount = Math.max(lineItemMinBidCount - existingLineItemBidCount, 0)

    const isLineItemCommonSubmitMode = lineItemMinBidCount > 1 && remainingLineItemBidCount > 0

    const lineItemColumnLabelMap = useMemo(
        () => ({
            brand: phrase.brand || 'Brand',
            asset_type: phrase.asset_type || 'Asset Type',
            category: phrase.category || 'Category',
            part_number: phrase.part_number || 'Part Number',
            product_name: phrase.product_name || 'Product Name',
            model: phrase.model || 'Model',
            generation: phrase.generation || 'Generation',
            socket: phrase.socket || 'Socket',
            memory_type: phrase.memory_type || 'Memory Type',
            form_factor: phrase.form_factor || 'Form Factor',
            ports: phrase.ports || 'Ports',
            manufacturer: phrase.manufacturer || 'Manufacturer',
            memory_size: phrase.memory_size || 'Memory Size',
            memory_rank: phrase.memory_rank || 'Memory Rank',
            memory_speed: phrase.memory_speed || 'Memory Speed',
            capacity: phrase.capacity || 'Capacity',
            price: phrase.price || 'Price',
            sprice: phrase.start_price || 'Start Price',
            start_pr: phrase.start_price || 'Start Price',
            start_price: phrase.start_price || 'Start Price',
            startprice: phrase.start_price || 'Start Price',
        }),
        [
            phrase.asset_type,
            phrase.brand,
            phrase.capacity,
            phrase.category,
            phrase.form_factor,
            phrase.generation,
            phrase.manufacturer,
            phrase.memory_rank,
            phrase.memory_size,
            phrase.memory_speed,
            phrase.memory_type,
            phrase.model,
            phrase.part_number,
            phrase.ports,
            phrase.product_name,
            phrase.price,
            phrase.socket,
            phrase.start_price,
        ],
    )

    const dynamicLineItemColumns = useMemo(() => {
        const columnsToRender = LINE_ITEM_TABLE_COLUMNS[lineItemTemplateType] || []

        return columnsToRender.map((columnKey) => ({
            key: columnKey,
            label:
                lineItemColumnLabelMap[columnKey] ||
                phrase[columnKey] ||
                humanizeLineItemKey(columnKey),
        }))
    }, [lineItemColumnLabelMap, lineItemTemplateType, phrase])

    const allLineItemColumns = useMemo(() => {
        const columnsToRender = LINE_ITEM_DETAIL_COLUMNS[lineItemTemplateType] || []
        return columnsToRender.map((columnKey) => ({
            key: columnKey,
            label:
                lineItemColumnLabelMap[columnKey] ||
                phrase[columnKey] ||
                humanizeLineItemKey(columnKey),
        }))
    }, [lineItemColumnLabelMap, lineItemTemplateType, phrase])

    const primaryLineItemColumnKey = useMemo(() => {
        if (dynamicLineItemColumns.length === 0) return ''

        const preferredKeys = ['asset_type', 'product_name', 'model', 'capacity', 'part_number']
        const preferredColumn = dynamicLineItemColumns.find((column) =>
            preferredKeys.includes(column.key),
        )
        if (preferredColumn) return preferredColumn.key

        const firstNonBrand = dynamicLineItemColumns.find(
            (column) => column.key !== 'brand' && column.key !== 'category',
        )
        return (firstNonBrand || dynamicLineItemColumns[0]).key
    }, [dynamicLineItemColumns])

    const lineItemTableColumnCount = useMemo(() => {
        const currentBidColumnCount = product.bidtype != 'sealed' ? 1 : 0
        const statusColumnCount = 1
        return (
            1 + // SubLot ID
            dynamicLineItemColumns.length +
            1 + // QTY
            currentBidColumnCount +
            1 + // Action
            statusColumnCount
        )
    }, [dynamicLineItemColumns.length, product.bidtype])
    const useImageZoom = () => {
        const [zoom, setZoom] = useState(1)
        const [position, setPosition] = useState({ x: 0, y: 0 })
        const [isDragging, setIsDragging] = useState(false)
        const dragStart = useRef({ x: 0, y: 0 })
        const lastZoom = useRef(1)

        const clamp = (value, min, max) => Math.min(Math.max(value, min), max)

        const handleWheel = (e) => {
            e.preventDefault()
            const delta = e.deltaY < 0 ? 1.12 : 0.89
            let newZoom = zoom * delta
            newZoom = clamp(newZoom, 1, 9)

            if (newZoom <= 1.01) {
                newZoom = 1
                setPosition({ x: 0, y: 0 })
            } else {
                setPosition((prev) => ({
                    x: prev.x * (newZoom / zoom),
                    y: prev.y * (newZoom / zoom),
                }))
            }

            lastZoom.current = newZoom
            setZoom(newZoom)
        }

        const handleMouseDown = (e) => {
            if (zoom <= 1) return
            e.preventDefault()
            setIsDragging(true)
            dragStart.current = { x: e.clientX - position.x, y: e.clientY - position.y }
        }

        const handleMouseMove = (e) => {
            if (!isDragging) return

            const maxX = ((zoom - 1) * window.innerWidth) / 2
            const maxY = ((zoom - 1) * window.innerHeight) / 2
            const newX = clamp(e.clientX - dragStart.current.x, -maxX, maxX)
            const newY = clamp(e.clientY - dragStart.current.y, -maxY, maxY)

            setPosition({ x: newX, y: newY })
        }

        const handleMouseUp = () => setIsDragging(false)

        const reset = () => {
            setZoom(1)
            setPosition({ x: 0, y: 0 })
            setIsDragging(false)
            lastZoom.current = 1
        }

        return {
            zoom,
            position,
            isDragging,
            handleWheel,
            handleMouseDown,
            handleMouseMove,
            handleMouseUp,
            reset,
        }
    }

    const zoom = useImageZoom()
    useEffect(() => {
        if (zoomOpen) {
            document.body.style.overflow = 'hidden'
            document.body.style.touchAction = 'none'
        } else {
            document.body.style.overflow = ''
            document.body.style.touchAction = ''
        }

        const handleKey = (e) => {
            if (!zoomOpen) return
            if (e.key === 'ArrowLeft') {
                setZoomImageIndex((i) => (i === 0 ? images.length - 1 : i - 1))
                zoom.reset()
            }
            if (e.key === 'ArrowRight') {
                setZoomImageIndex((i) => (i === images.length - 1 ? 0 : i + 1))
                zoom.reset()
            }
            if (e.key === 'Escape') {
                setZoomOpen(false)
                zoom.reset()
            }
        }

        window.addEventListener('keydown', handleKey)
        return () => {
            document.body.style.overflow = ''
            document.body.style.touchAction = ''
            window.removeEventListener('keydown', handleKey)
        }
    }, [zoomOpen, images.length])

    const toggleFullscreen = (e) => {
        if (e) e.stopPropagation()

        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen?.()
        } else {
            document.exitFullscreen?.()
        }
    }

    // Listen for fullscreen changes
    useEffect(() => {
        const handler = () => setIsFullscreen(Boolean(document.fullscreenElement))
        document.addEventListener('fullscreenchange', handler)
        return () => document.removeEventListener('fullscreenchange', handler)
    }, [])

    const firstLineItemLoad = useRef(true)
    const bulkBidRef = useRef({}) // store info needed for bulk bidding
    const didBulkBid = useRef(false)
    const commonSubmitPendingSuccessAlerts = useRef(0)
    const commonSubmitSuppressSuccessUntil = useRef(0)

    let history = useHistory()
    const [state, setState] = useState({
        right: false,
        bottom: false,
        data: {},
    })
    // change results per page value
    const changePageLimit = (e) => {
        setLineItemsReady(false)
        setPageLimit(e.target.value)
        setPageNum(1)
    }
    const changePageHandler = (e, value) => {
        setLineItemsReady(false)
        setPageNum(value)
    }
    const getLineItemProducts = () => {
        let endPoint = `getLineItemsProduct${isAuthenticated ? '' : '_new'}?ajax=1&sh_limit=${
            pageLimitRef.current
        }&page=${pageNumRef.current}&project_id=${product.id}`
        apiCall('get', endPoint, '', '', 'product').then((res) => {
            if (res.data.status == 'success') {
                let lineItemsTemp = []
                if (res.data.data.subproject.length == 0) {
                    lineItemsTemp.push(
                        <tr>
                            <td colSpan="5" className="text-center">
                                No line items available
                            </td>
                        </tr>,
                    )
                } else {
                    setTotalProductCnt(res.data.data.total_pagecnt)
                    setPageDescription(res.data.data.set_disp)
                    const lineDataRows = Array.isArray(product?.linedata) ? product.linedata : []
                    let lineItemMeta = {}
                    for (var i of lineDataRows) {
                        const templateFieldValues = {}
                        for (const rawKey of Object.keys(i || {})) {
                            const canonicalKey = getCanonicalLineItemKey(rawKey)
                            if (!canonicalKey) continue
                            if (
                                typeof templateFieldValues[canonicalKey] === 'undefined' ||
                                !isLineItemValuePresent(templateFieldValues[canonicalKey])
                            ) {
                                templateFieldValues[canonicalKey] = i[rawKey]
                            }
                        }

                        lineItemMeta[i.id] = {
                            templateFieldValues,
                            partNumber: i.part_number || '',
                            memorySpeed:
                                i.memory_speed ||
                                i.memorySpeed ||
                                i['memory speed'] ||
                                i['Memory Speed'] ||
                                '',
                            memorySize:
                                i.memory_size ||
                                i.memorySize ||
                                i['memory size'] ||
                                i['Memory Size'] ||
                                '',
                            memoryRank:
                                i.memory_rank ||
                                i.memoryRank ||
                                i['memory rank'] ||
                                i['Memory Rank'] ||
                                '',
                        }
                    }

                    lineItemsTemp = res.data.data.subproject.map((item) => {
                        let companyHasBid = 0
                        if (user.companyid && user.companyid != '' && user.companyid != '0') {
                            companyHasBid = item.companynot
                        }

                        const itemMeta = lineItemMeta[item.id] || {}
                        return {
                            id: item.id,
                            category_id: item.category_id,
                            title: item.title,
                            description: item.description,
                            qty: item.qty,
                            currency: item.currency,
                            currency_symbol: item.currency_symbol,
                            wpriceview: item.wpriceview,
                            wprice: item.wprice,
                            rprice: item.rprice,
                            next_bid: parseLineItemBidInteger(item.next_bid, 0),
                            bidtopstatus: item.bidtopstatus, // status column, status of user's bid
                            bidPrice: parseLineItemBidInteger(item.bidderproxyant, 0),
                            market_status: product.market_status,
                            master_id: product.id,
                            auctiontype: product.auctiontype,
                            bidtype: item.bidtype,
                            lottype: item.lottype,
                            csvfile: product.csvfile,
                            incrementAmt: item.incrementamt,
                            bid_count: item.bid_count || item.bidcount || 0,
                            partNumber: itemMeta.partNumber || '',
                            memorySpeed: itemMeta.memorySpeed || '',
                            memorySize: itemMeta.memorySize || '',
                            memoryRank: itemMeta.memoryRank || '',
                            templateFieldValues: itemMeta.templateFieldValues || {},
                            hasBid: item.cbidnot,
                            companyHasBid: companyHasBid,
                            isSocketUpdate: false,
                        }
                    })
                }

                setLineItems(lineItemsTemp)
                setLineItemsReady(true)
            }
        })
    }

    // download buyer's bid status
    const downloadBidStatus = () => {
        apiCall('get', `downloadBidStatus/${product.id}`, '', '', 'product').then((res) => {
            window.location.href = res.data.filePath
        })
    }

    const lineItemsRef = useRef(lineItems) // line items on the page
    const bulkBidLineItemsRef = useRef(bulkBidLineItems)
    const userRef = useRef(user)
    const pageNumRef = useRef(pageNum)
    const pageLimitRef = useRef(pageLimit)
    const productRef = useRef(product)
    useEffect(() => {
        bulkBidLineItemsRef.current = bulkBidLineItems
        userRef.current = user
        lineItemsRef.current = lineItems
        pageNumRef.current = pageNum
        pageLimitRef.current = pageLimit
        productRef.current = product
    })

    const socketHandler = (data, type) => {
        lineItemBidSocketHandler(
            data,
            type,
            userRef.current,
            lineItemsRef.current,
            bulkBidLineItemsRef.current,
            didBulkBid.current,
            setLineItems,
            setDwBidStatus,
            setBulkBidLineItems,
            setAlert,
            phrase,
            commonSubmitPendingSuccessAlerts,
            commonSubmitSuppressSuccessUntil,
        )
    }

    // Extended Bidding: a bid placed near the end of a line item extends the
    // auction closing time (same behavior as lot level auctions).
    const bidExtendedHandler = (data) => {
        const currentProduct = productRef.current
        if (!currentProduct || !data || !data.date_extended) return

        const extendedId = parseInt(data.product_id, 10)
        const isParentLot = extendedId === parseInt(currentProduct.id, 10)
        const isLineItemOnPage = lineItemsRef.current.some(
            (lineItem) => parseInt(lineItem.id, 10) === extendedId,
        )
        // Only react to extensions that belong to this lot or one of its line items
        if (!isParentLot && !isLineItemOnPage) return

        const extendedTimeMs = new Date(data.date_extended).getTime()
        if (Number.isNaN(extendedTimeMs)) return

        const currentCloseMs = new Date(currentProduct.date_closed).getTime()
        // Push the shared lot timer forward only when the new closing time is later
        if (Number.isNaN(currentCloseMs) || extendedTimeMs > currentCloseMs) {
            setProduct({ ...currentProduct, date_closed: data.date_extended })
        }
    }

    const cancelBidHandler = (data) => {
        let isLineOnScreen = lineItemsRef.current.findIndex((lineItem) => {
            return lineItem.id == data.project_id
        })
        if (isLineOnScreen !== -1) {
            getLineItemProducts()
        }
    }
    // define socket event handler on first render
    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, { transports: ['websocket'] })
        const onRealClosedUpdates = (data) => {
            socketHandler(data, 'realclosedupdates')
        }
        const onBidAddtime = (data) => {
            socketHandler(data, 'bidAddtime')
        }
        const onCancelBidEmitted = (data) => {
            cancelBidHandler(data)
        }
        const onBidExtended = (data) => {
            bidExtendedHandler(data)
        }

        socket.on('realclosedupdates', onRealClosedUpdates)
        socket.on('bidAddtime', onBidAddtime)
        // Bid Cancellation Event => Reload the product info
        socket.on('cancelbidemitted', onCancelBidEmitted)
        // Extended Bidding => extend the closing time when a late bid is placed
        socket.on('bid_extended', onBidExtended)
        return () => {
            socket.off('realclosedupdates', onRealClosedUpdates)
            socket.off('bidAddtime', onBidAddtime)
            socket.off('cancelbidemitted', onCancelBidEmitted)
            socket.off('bid_extended', onBidExtended)
            socket.disconnect()
        }
    }, [])

    useEffect(() => {
        let pageCount = Math.ceil(parseInt(totalProductCnt) / parseInt(pageLimit))
        setTotalPageCnt(pageCount)
    }, [totalProductCnt, pageLimit])

    useEffect(() => {
        if (firstLineItemLoad.current) firstLineItemLoad.current = false
        getLineItemProducts()
    }, [pageLimit, pageNum])

    useEffect(() => {
        if (product.id && !firstLineItemLoad.current) {
            getLineItemProducts()
        }
    }, [product.id])

    // set each line items view
    useLayoutEffect(() => {
        let lineItemsTemp = []
        if (lineItems.length == 0) {
            lineItemsTemp.push(
                <tr>
                    <td colSpan={lineItemTableColumnCount} className="text-center">
                        No line items available
                    </td>
                </tr>,
            )
        } else {
            let ref = {}
            lineItemsTemp = lineItems.map((item) => {
                ref[item.id] = {
                    next_bid: item.next_bid,
                    bid_increment: item.incrementAmt,
                }
                const getDynamicCellValue = (normalizedKey) => {
                    const fromTemplate = item.templateFieldValues?.[normalizedKey]
                    if (
                        fromTemplate !== null &&
                        typeof fromTemplate !== 'undefined' &&
                        !(typeof fromTemplate === 'string' && fromTemplate.trim() === '')
                    ) {
                        return toLineItemCellDisplayValue(fromTemplate)
                    }
                    return '-'
                }
                return (
                    <tr key={item.id}>
                        <td
                            scope="row"
                            data-title={phrase.sublot_id || 'SubLot ID'}
                            className="primeColor"
                            style={{ cursor: 'pointer' }}
                            onClick={toggleDrawer('right', true, {
                                id: item.id,
                            })}
                        >
                            {item.id}
                        </td>
                        {dynamicLineItemColumns.map((column) => {
                            const isPrimaryColumn = column.key === primaryLineItemColumnKey
                            const cellValue = getDynamicCellValue(column.key)
                            if (isPrimaryColumn) {
                                return (
                                    <td key={`${item.id}_${column.key}`} data-title={column.label}>
                                        {cellValue}
                                    </td>
                                )
                            }

                            return (
                                <td key={`${item.id}_${column.key}`} data-title={column.label}>
                                    {cellValue}
                                </td>
                            )
                        })}
                        <td data-title={phrase.qty || 'Qty'}>{item.qty}</td>
                        {product.bidtype != 'sealed' ? (
                            <td data-title={phrase.current_bid_per_unit || 'Current Bid per Unit'}>
                                <div>
                                    {item.currency} {item.currency_symbol}
                                    {item.wprice}
                                </div>
                                {isAuthenticated ? (
                                    <Button
                                        className="viewBids red"
                                        style={{
                                            color: 'var(--primColor)',
                                            fontSize: '12px',
                                            textTransform: 'none',
                                            display: 'block',
                                            minWidth: 'unset',
                                            margin: '4px 0 0',
                                            padding: 0,
                                            lineHeight: 1.2,
                                        }}
                                        onClick={() => setBidHistoryValue(item.id)}
                                    >
                                        {phrase.view_all_bids} ({parseInt(item.bid_count || 0, 10)})
                                    </Button>
                                ) : (
                                    <p
                                        className="red"
                                        style={{
                                            color: 'var(--primColor)',
                                            fontSize: '12px',
                                            margin: '4px 0 0',
                                            lineHeight: 1.2,
                                        }}
                                    >
                                        {phrase.view_all_bids} ({parseInt(item.bid_count || 0, 10)})
                                    </p>
                                )}
                            </td>
                        ) : null}
                        <td data-title={phrase.action || 'Action'}>
                            <div className="lineItemAction">
                                {(item.market_status == 'open' || item.isSocketUpdate) &&
                                !isAuctionNotStarted &&
                                !isAuctionEnded ? (
                                    <>
                                        {item.bidPrice > 0 && item.market_status == 'open' ? (
                                            item.wprice >= item.rprice ? (
                                                <p>{phrase.reserve_price_is_met}</p>
                                            ) : (
                                                <p className="red">
                                                    {phrase.reserve_price_is_not_met}
                                                </p>
                                            )
                                        ) : null}

                                        {isLineItemCommonSubmitMode ? (
                                            <div className="lineItemCommonBidInputCnt">
                                                <input
                                                    type="text"
                                                    value={getLineItemInputValue(item.id)}
                                                    onChange={(e) =>
                                                        handleLineItemBidInputChange(
                                                            item,
                                                            e.target.value,
                                                        )
                                                    }
                                                    placeholder={phrase.enter_bid || 'Enter bid'}
                                                    disabled={
                                                        item.market_status != 'open' ||
                                                        !user.isBuyer
                                                    }
                                                />
                                                <p
                                                    className={
                                                        isLineItemBidInputValid(item.id)
                                                            ? 'lineItemBidHint'
                                                            : 'lineItemBidHint red'
                                                    }
                                                >
                                                    {`${
                                                        phrase.enter || 'Enter'
                                                    } ${getLineItemMinRequiredBid(item)} ${
                                                        item.currency
                                                    } ${phrase.or_more || 'or more'}`}
                                                </p>
                                            </div>
                                        ) : (
                                            <BiddingItem
                                                product={item}
                                                phrases={phrase}
                                                wsprice={item.bidPrice}
                                                handleClose={() => {}}
                                            />
                                        )}
                                    </>
                                ) : null}
                                {product.bidtype == 'sealed' && item.market_status != 'open' ? (
                                    isAuthenticated ? (
                                        <Button
                                            className="viewBids red"
                                            style={{
                                                color: 'var(--primColor)',
                                                fontSize: '12px',
                                                textTransform: 'none',
                                                minWidth: 'unset',
                                                margin: '4px 0 0',
                                                padding: 0,
                                                lineHeight: 1.2,
                                            }}
                                            onClick={() => setBidHistoryValue(item.id)}
                                        >
                                            {phrase.view_all_bids} (
                                            {parseInt(item.bid_count || 0, 10)})
                                        </Button>
                                    ) : (
                                        <p
                                            className="red"
                                            style={{
                                                color: 'var(--primColor)',
                                                fontSize: '12px',
                                                margin: '4px 0 0',
                                                lineHeight: 1.2,
                                            }}
                                        >
                                            {phrase.view_all_bids} (
                                            {parseInt(item.bid_count || 0, 10)})
                                        </p>
                                    )
                                ) : null}
                            </div>
                        </td>

                        {product.bidtype != 'sealed' ? (
                            <td
                                data-title={phrase.status || 'Status'}
                                dangerouslySetInnerHTML={{
                                    __html: item.bidtopstatus,
                                }}
                            ></td>
                        ) : null}
                    </tr>
                )
            })
            bulkBidRef.current = ref
            setLineItemsView(lineItemsTemp)
            setLineItemsReady(true)
        }
    }, [
        dynamicLineItemColumns,
        isAuthenticated,
        isAuctionNotStarted,
        isLineItemCommonSubmitMode,
        lineItemBidInputs,
        lineItemTableColumnCount,
        lineItems,
        phrase.action,
        phrase.current_bid_per_unit,
        phrase.enter,
        phrase.enter_bid,
        phrase.or_more,
        phrase.qty,
        phrase.reserve_price_is_met,
        phrase.reserve_price_is_not_met,
        phrase.status,
        phrase.sublot_id,
        phrase.view_all_bids,
        primaryLineItemColumnKey,
        lineItemTemplateType,
        product.bidtype,
        setBidHistoryValue,
        user.isBuyer,
    ])

    useEffect(() => {
        if (Object.keys(bulkBidLineItems).length > 0) {
            let table = []
            for (let item of bulkBidLineItems) {
                let tableRow = (
                    <>
                        <tr>
                            <td>{item.brand}</td>
                            <td>{item.product_name}</td>
                            <td>{item.category}</td>
                            <td>{item.qty}</td>
                            <td>
                                {item.wsprice} {product.currency}
                            </td>
                            {item.status}
                        </tr>
                    </>
                )
                table.push(tableRow)
            }
            // set the bulk bid line item table in the modal
            setBulkBidTable(table)
        }
    }, [bulkBidLineItems])

    // BULK BIDDING, once bulk bid item table is set, open the modal
    useEffect(() => {
        if (bulkBidTable.length > 0) {
            setBulkBidPopupOpen(true)
        }
    }, [bulkBidTable])
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            const lineDataRows = Array.isArray(product?.linedata) ? product.linedata : []
            let lineDataIndex = lineDataRows.findIndex((lindata) => {
                return lindata.id == data.id
            })
            const selectedLineItem = lineItems.find((lineItem) => lineItem.id == data.id)
            const lineDataRow = lineDataIndex === -1 ? {} : lineDataRows[lineDataIndex]

            const lineItemData = {
                id: data.id,
            }

            const titleValue =
                selectedLineItem?.templateFieldValues?.product_name ||
                selectedLineItem?.title ||
                lineDataRow.product_name ||
                lineDataRow.asset_type ||
                lineDataRow.model ||
                lineDataRow.part_number ||
                ''
            if (isLineItemValuePresent(titleValue)) {
                lineItemData.product_name = titleValue
            }

            for (const column of allLineItemColumns) {
                let value = selectedLineItem?.templateFieldValues?.[column.key]

                if (!isLineItemValuePresent(value)) {
                    for (const rawKey of Object.keys(lineDataRow || {})) {
                        if (getCanonicalLineItemKey(rawKey) === column.key) {
                            const rowValue = lineDataRow[rawKey]
                            if (isLineItemValuePresent(rowValue)) {
                                value = rowValue
                                break
                            }
                        }
                    }
                }

                if (isLineItemValuePresent(value)) {
                    lineItemData[column.key] = toLineItemCellDisplayValue(value)
                }
            }

            if (selectedLineItem && isLineItemValuePresent(selectedLineItem.qty)) {
                lineItemData.qty = selectedLineItem.qty
            }

            setState({ ...state, [anchor]: open, data: lineItemData })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    const bidInstructionHandler = () => {
        setBidInstructionOpen(true)
    }
    const bidInstructionClose = () => {
        setBidInstructionOpen(false)
    }

    let downloadManifestFile = downloadFile
    const redirectToManifestFile = () => {
        window.location.href = `${global.site_url}/uploads/product_csv/${product.buyer_manifest_file}`
    }
    if (
        typeof product.download_complete_manifest !== 'undefined' &&
        product.download_complete_manifest != ''
    ) {
        downloadManifestFile = redirectToManifestFile
    }

    const openCsvBidFile = () => {
        document.getElementById('bid_csv').click()
    }
    const bulkBidPopupClose = () => {
        // re-initialize
        didBulkBid.current = false
        setBulkBidPopupOpen(false)
        setBulkBidLineItems([])
        setBulkBidTable([])
    }
    const uploadBulkBidding = (e) => {
        var formData = new FormData()
        var bidFile = document.querySelector('#bid_csv')
        if (bidFile.files.length > 0) {
            formData.append('bid_csv', bidFile.files[0])
            formData.append('project_id', product.id)
            formData.append('currency', product.currency)
            apiCall('post', 'upload-bid-csv-lineitem', formData, 'formdata', 'product', {
                imagesession: 1,
            })
                .then((res) => {
                    if (res.data.msgdata == 'success') {
                        let productCopy = { ...product }
                        productCopy.csvfile = res.data.csvfile
                        setProduct(productCopy)

                        var productBidArray = res.data.productBidArray
                        var bulkBids = []
                        for (let item of res.data.productBidArray) {
                            if (
                                parseLineItemBidInteger(item.wsprice, 0) >=
                                bulkBidRef.current[item.id].next_bid
                            ) {
                                item.status = (
                                    <td className="alert alert-warning">
                                        {phrase.waitingforconfirmation}
                                    </td>
                                )
                                item.bid_increment = bulkBidRef.current[item.id].bid_increment
                                item.csvfile = e.target.value
                                bulkBids.push(item)
                            }
                        }
                        setBulkBidLineItems(bulkBids)
                        // to re-upload again
                        e.target.value = null
                    }
                })
                .catch((err) => {
                    setAlert(
                        phrase['something_wrong_happened'] ||
                            'Something wrong happend.. Please try again.',
                        'error',
                    )
                })
        }
    }
    const submitBulkBidding = () => {
        let bidArr = [...bulkBidLineItems]
        if (bidArr.length > 0) {
            for (let bid of bidArr) {
                var bidData = {
                    auctionType: 'lineitem',
                    isLineitem: true,
                    bidType: product.bidtype,
                    lotType: '',
                    id: bid.id,
                    bid_increment: bid.bid_increment,
                    wsprice: bid.wsprice,
                    master_id: product.id,
                }
                // submit bid, response will be captured in socket event
                apiCall('post', 'bidConfirm', bidData, '', 'product')
            }
            // re-initialize the bulk bid array
            didBulkBid.current = true
        }
    }

    const contactPopupOpen = () => {
        setContactPopup(true)
    }
    const contactPopupClose = () => {
        setContactPopup(false)
    }
    const productDescClose = () => {
        setProductDescPopup(false)
    }
    const contactSeller = () => {
        let msg = document.getElementById('contactSellerMsg')
        if (msg.value != '') {
            contactPopupClose()
            let data = {}
            data.to_id = product.sellerid
            data.projectmsgpost = product.id
            data.message = msg.value
            data.from_id = user.id
            apiCall('post', 'savemessagefromview', data, '', 'messages')
                .then((res) => {
                    msg.value = ''
                    setAlert(phrase.message_successfully_sent, 'success')
                })
                .catch((err) => {
                    setAlert(
                        phrase['something_wrong_happened'] ||
                            'Something wrong happend.. Please try again.',
                        'error',
                    )
                })
        }
    }

    let categories = ''
    if (product) {
        for (let i in product.multiplecategoryshow) {
            if (i == product.multiplecategoryshow.length - 1) {
                // last index
                //categories += product.multiplecategoryshow[i]
                categories += phrase[product.multiplecategoryshow[i]]
            } else {
                //categories += product.multiplecategoryshow[i] + ', '
                categories += phrase[product.multiplecategoryshow[i]] + ', '
            }
        }
    }
    const showPagination = parseInt(totalProductCnt) > parseInt(pageLimit)

    const getLineItemMinRequiredBid = (item) => {
        const currentBid = parseLineItemBidInteger(item?.wprice, 0)
        const nextBid = parseLineItemBidInteger(item?.next_bid, 0)
        return item?.bidtype == 'sealed' && currentBid > 0 ? currentBid + 1 : nextBid
    }

    const getLineItemInputValue = (lineItemId) => lineItemBidInputs[lineItemId]?.displayValue || ''

    const isLineItemBidInputValid = (lineItemId) => {
        const input = lineItemBidInputs[lineItemId]
        if (!input) return false
        return parseLineItemBidInteger(input.rawValue, 0) >= getLineItemMinRequiredBid(input)
    }

    const getValidLineItemBidEntries = () => {
        const validEntries = []
        for (const lineItemId of Object.keys(lineItemBidInputs)) {
            if (!isLineItemBidInputValid(lineItemId)) continue
            validEntries.push(lineItemBidInputs[lineItemId])
        }
        return validEntries
    }

    const formatPhraseTemplate = (template, replacements = {}) => {
        return String(template || '').replace(/\{(\w+)\}/g, (_, key) => {
            return Object.prototype.hasOwnProperty.call(replacements, key)
                ? String(replacements[key])
                : `{${key}}`
        })
    }

    const handleLineItemBidInputChange = (item, value) => {
        const normalizedValue = String(value ?? '')
            .replace(/,/g, '')
            .replace(/[^\d.]/g, '')
        const parts = normalizedValue.split('.')
        const integerPart = parts.shift().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        const displayValue = parts.length
            ? `${integerPart}.${parts.join('').slice(0, 2)}`
            : integerPart
        const rawValue = String(displayValue).replace(/,/g, '')

        setLineItemBidInputs((prev) => ({
            ...prev,
            [item.id]: {
                id: item.id,
                rawValue,
                displayValue,
                next_bid: item.next_bid,
                bidtype: item.bidtype,
                wprice: item.wprice,
                incrementAmt: item.incrementAmt,
                market_status: item.market_status,
            },
        }))

        if (lineItemCommonError) {
            setLineItemCommonError('')
        }
    }

    const submitLineItemBidsCommon = async () => {
        if (isSubmittingLineItemCommonBid) return

        if (isAuctionNotStarted) {
            setLineItemCommonError(phrase.auction_not_started || 'Auction has not started yet')
            return
        }

        const validEntries = getValidLineItemBidEntries()
        const existingBidProductIds = new Set(
            lineItems.filter((item) => hasExistingLineItemBid(item)).map((item) => String(item.id)),
        )
        const newBidProductIds = new Set(
            validEntries
                .filter((entry) => entry.market_status == 'open')
                .map((entry) => String(entry.id)),
        )
        const projectedBidCount = new Set([...existingBidProductIds, ...newBidProductIds]).size

        if (projectedBidCount < lineItemMinBidCount) {
            const remainingCount = lineItemMinBidCount - projectedBidCount
            setLineItemCommonError(
                formatPhraseTemplate(
                    phrase.lineitem_common_submit_min_error ||
                        'Please enter bids for at least {minCount} products before submitting. You currently have {projectedCount} counted products with bids, so {remainingCount} more products are required.',
                    {
                        minCount: lineItemMinBidCount,
                        projectedCount: projectedBidCount,
                        remainingCount,
                    },
                ),
            )
            return
        }

        const payloads = validEntries
            .filter((entry) => entry.market_status == 'open')
            .map((entry) => ({
                auctionType: 'lineitem',
                isLineitem: true,
                bidType: entry.bidtype,
                lotType: '',
                id: entry.id,
                bid_increment: parseLineItemBidInteger(entry.incrementAmt, 0),
                wsprice: parseLineItemBidInteger(entry.rawValue, 0),
                master_id: product.id,
            }))

        if (payloads.length === 0) {
            setLineItemCommonError(
                phrase.lineitem_no_open_line_items_with_valid_bids ||
                    'No open line items with valid bids are available for submission.',
            )
            return
        }

        try {
            setIsSubmittingLineItemCommonBid(true)
            // Reset previous suppression window before setting new one
            // This ensures each new bid submission shows notificationsb
            commonSubmitPendingSuccessAlerts.current = 0
            commonSubmitSuppressSuccessUntil.current = 0
            commonSubmitPendingSuccessAlerts.current = payloads.length
            commonSubmitSuppressSuccessUntil.current = Date.now() + 10000
            await Promise.all(
                payloads.map((payload) => apiCall('post', 'bidConfirm', payload, '', 'product')),
            )
            // Update local line items immediately to mark bids as placed
            // This prevents getLineItemProducts() from overwriting with stale data
            const submittedIds = new Set(payloads.map((p) => p.id))
            setLineItems((prev) =>
                prev.map((item) => (submittedIds.has(item.id) ? { ...item, hasBid: 1 } : item)),
            )
            // Clear bid inputs after successful submission
            const submittedIdsStr = new Set(payloads.map((p) => String(p.id)))
            setLineItemBidInputs((prev) => {
                const next = { ...prev }
                for (const id of submittedIdsStr) {
                    delete next[id]
                }
                return next
            })
            setLineItemCommonError('')
            setAlert(
                phrase.lineitem_bids_submitted_successfully || 'Bids submitted successfully',
                'success',
            )
            getLineItemProducts()
        } catch (err) {
            setAlert(
                phrase['something_wrong_happened'] || 'Something wrong happend.. Please try again.',
                'error',
            )
        } finally {
            setIsSubmittingLineItemCommonBid(false)
        }
    }

    useEffect(() => {
        if (!isLineItemCommonSubmitMode) {
            setLineItemBidInputs({})
            setLineItemCommonError('')
        }
    }, [isLineItemCommonSubmitMode])

    useEffect(() => {
        if (!isLineItemCommonSubmitMode || !lineItems.length) return

        setLineItemBidInputs((prev) => {
            const next = { ...prev }
            let hasChange = false

            for (const item of lineItems) {
                if (!next[item.id]) continue
                const current = next[item.id]
                if (
                    current.next_bid !== item.next_bid ||
                    current.wprice !== item.wprice ||
                    current.bidtype !== item.bidtype ||
                    current.incrementAmt !== item.incrementAmt ||
                    current.market_status !== item.market_status
                ) {
                    next[item.id] = {
                        ...current,
                        next_bid: item.next_bid,
                        wprice: item.wprice,
                        bidtype: item.bidtype,
                        incrementAmt: item.incrementAmt,
                        market_status: item.market_status,
                    }
                    hasChange = true
                }
            }

            return hasChange ? next : prev
        })
    }, [isLineItemCommonSubmitMode, lineItems])

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTimeMs(Date.now())
        }, 1000)

        return () => clearInterval(interval)
    }, [])

    return (
        <>
            <div className="auctionView lineItemView container-fluid mt-2">
                <div className="customContainer">
                    <div className="d-flex justify-content-start">
                        <Button className="backBtn my-2" onClick={() => history.goBack()}>
                            <span className="material-icons">arrow_back</span>Back
                        </Button>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12 position-relative image-zoom-overlay">
                            {user.isBuyer && product.isclosed >= 0 ? (
                                <FavoriteCheckbox
                                    watchlisted={product.isWatchlisted}
                                    project_id={product.id}
                                />
                            ) : null}
                            <ImageGallery
                                items={images}
                                thumbnailPosition="bottom"
                                showNav={false}
                                showBullets={false}
                                showFullscreenButton={false}
                                showPlayButton={false}
                                autoPlay={true}
                                lazyLoad={true}
                                renderItem={(item) => (
                                    <div className="image-gallery-image text-center">
                                        <img
                                            src={item.original || item.src}
                                            alt={getProductImageAlt(product, phrase)}
                                            style={{
                                                cursor: 'zoom-in',
                                                maxWidth: '100%',
                                                maxHeight: '320px',
                                                objectFit: 'contain',
                                            }}
                                            onClick={() => {
                                                setZoomImageIndex(images.indexOf(item))
                                                setZoomOpen(true)
                                                zoom.reset()
                                            }}
                                        />
                                    </div>
                                )}
                            />

                            {zoomOpen && (
                                <div
                                    style={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        width: '100vw',
                                        height: '100vh',
                                        background: 'rgba(0,0,0,0.98)',
                                        zIndex: 9999,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        overflow: 'hidden',
                                    }}
                                    className="mobile-only"
                                    onClick={() => {
                                        setZoomOpen(false)
                                        zoom.reset()
                                    }}
                                    onWheel={zoom.handleWheel}
                                >
                                    <Button
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            setZoomOpen(false)
                                            zoom.reset()
                                        }}
                                        style={{
                                            position: 'absolute',
                                            top: 15,
                                            right: 15,
                                            zIndex: 10001,
                                            minWidth: 50,
                                            width: 50,
                                            height: 50,
                                            background: 'rgb(255 255 255 / 12%)',
                                            color: '#ffffffff',
                                            borderRadius: '50%',
                                            fontSize: 28,
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        <span className="material-icons">close</span>
                                    </Button>
                                    <Button
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            toggleFullscreen(e)
                                        }}
                                        style={{
                                            position: 'absolute',
                                            top: 15,
                                            right: 'clamp(15px, 15vh, 90px)',
                                            width: '50px',
                                            minWidth: '50px',
                                            height: '50px',
                                            borderRadius: '50%',
                                            background: 'rgb(255 255 255 / 12%)',
                                            color: '#ffffffff',
                                            fontSize: '28px',
                                            fontWeight: 'bold',
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
                                            zIndex: 10001,
                                        }}
                                    >
                                        <span className="material-icons">
                                            {isFullscreen ? 'fullscreen_exit' : 'fullscreen'}
                                        </span>
                                    </Button>
                                    <img
                                        src={
                                            images[zoomImageIndex]?.original ||
                                            images[zoomImageIndex]?.src
                                        }
                                        alt="Zoom"
                                        onClick={(e) => e.stopPropagation()}
                                        onWheel={zoom.handleWheel}
                                        onMouseDown={zoom.handleMouseDown}
                                        onMouseMove={zoom.handleMouseMove}
                                        onMouseUp={zoom.handleMouseUp}
                                        onMouseLeave={zoom.handleMouseUp}
                                        draggable={false}
                                        style={{
                                            maxWidth: '100vw',
                                            maxHeight: '100vh',
                                            objectFit: 'contain',
                                            transform: `translate(${zoom.position.x}px, ${zoom.position.y}px) scale(${zoom.zoom})`,
                                            transition: zoom.isDragging
                                                ? 'none'
                                                : 'transform 0.2s ease-out',
                                            cursor:
                                                zoom.zoom > 1
                                                    ? zoom.isDragging
                                                        ? 'grabbing'
                                                        : 'grab'
                                                    : 'zoom-out',
                                            userSelect: 'none',
                                        }}
                                    />
                                    {window.innerWidth > 768 && (
                                        <>
                                            <Button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    setZoomImageIndex((i) =>
                                                        i === 0 ? images.length - 1 : i - 1,
                                                    )
                                                    zoom.reset()
                                                }}
                                                style={{
                                                    position: 'absolute',
                                                    left: 20,
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    zIndex: 10000,
                                                    background: 'rgba(255, 255, 255, 0)',
                                                    color: '#ffffffff',
                                                    borderRadius: '50%',
                                                    width: 60,
                                                    minWidth: 60,
                                                    height: 60,
                                                    fontSize: 36,
                                                }}
                                            >
                                                <span className="material-icons">
                                                    keyboard_backspace
                                                </span>
                                            </Button>
                                            <Button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    setZoomImageIndex((i) =>
                                                        i === images.length - 1 ? 0 : i + 1,
                                                    )
                                                    zoom.reset()
                                                }}
                                                style={{
                                                    position: 'absolute',
                                                    right: 20,
                                                    top: '50%',
                                                    transform: 'translateY(-50%) rotate(180deg)',
                                                    zIndex: 10000,
                                                    background: 'rgba(255, 255, 255, 0)',
                                                    color: '#ffffffff',
                                                    borderRadius: '50%',
                                                    minWidth: 60,
                                                    width: 60,
                                                    height: 60,
                                                    fontSize: 36,
                                                }}
                                            >
                                                <span className="material-icons">
                                                    keyboard_backspace
                                                </span>
                                            </Button>
                                        </>
                                    )}
                                    {window.innerWidth <= 768 && (
                                        <div
                                            className="mobile-only"
                                            style={{
                                                position: 'absolute',
                                                bottom: 0,
                                                width: '100%',
                                                height: 100,
                                                background:
                                                    'linear-gradient(transparent, rgba(0,0,0,0.8))',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: 40,
                                                paddingBottom: 'env(safe-area-inset-bottom)',
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <Button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    setZoomImageIndex((i) =>
                                                        i === 0 ? images.length - 1 : i - 1,
                                                    )
                                                    zoom.reset()
                                                    if (navigator.vibrate) navigator.vibrate(30)
                                                }}
                                                style={{
                                                    width: 70,
                                                    height: 70,
                                                    borderRadius: '50%',
                                                    background: 'white',
                                                    color: 'black',
                                                    fontSize: 40,
                                                }}
                                            >
                                                <span className="material-icons">
                                                    keyboard_backspace
                                                </span>
                                            </Button>

                                            <div style={{ color: 'white', fontSize: 16 }}>
                                                {zoomImageIndex + 1} / {images.length}
                                            </div>

                                            <Button
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    setZoomImageIndex((i) =>
                                                        i === images.length - 1 ? 0 : i + 1,
                                                    )
                                                    zoom.reset()
                                                    if (navigator.vibrate) navigator.vibrate(30)
                                                }}
                                                style={{
                                                    width: 70,
                                                    height: 70,
                                                    borderRadius: '50%',
                                                    background: 'white',
                                                    transform: 'rotate(180deg)',
                                                    color: 'black',
                                                    fontSize: 40,
                                                }}
                                            >
                                                <span className="material-icons">
                                                    keyboard_backspace
                                                </span>
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="col-lg-8 col-md-6 col-12">
                            <div className="lineItemTimerCnt primeColor">
                                {!isAuctionEnded && (
                                    <label>
                                        {isAuctionNotStarted
                                            ? phrase['starts_in'] || 'STARTS IN'
                                            : phrase['ends_in'] || 'ENDS IN'}
                                    </label>
                                )}
                                <Timer
                                    date_added={product.date_added}
                                    date_closed={product.date_closed}
                                    withText={0}
                                ></Timer>
                            </div>
                            <h1 className="pvTitle">{product.title}</h1>

                            <div className="lineItemInfo">
                                <div>
                                    <div className="pvGrid">
                                        <div className="pvGrid">
                                            <label> {phrase.no_of_items}</label>
                                            <span>{product.qty}</span>
                                        </div>
                                        <div className="pvGrid">
                                            <label>{phrase.condition}</label>
                                            <span>
                                                {phrase[product.condition]
                                                    ? phrase[product.condition]
                                                    : product.condition}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="pvGrid">
                                        {/* <div className="pvGrid">
                                            <label>{phrase.lot_size}</label>
                                            <span>
                                                {' '}
                                                {phrase[product.lottype]} {phrase.lot}
                                            </span>
                                        </div> */}
                                        <div className="pvGrid">
                                            <label> {phrase.location} </label>
                                            <span> {product.country} </span>
                                        </div>
                                        <div className="pvGrid">
                                            <label>{phrase.category}</label>
                                            <span>{categories}</span>
                                        </div>
                                    </div>

                                    <div className="pvGrid">
                                        {/* <div className="pvGrid">
                                            <label> {phrase.auction_type} </label>
                                            <span> {phrase.auction_type} </span>
                                        </div> */}
                                        {/* <div className="pvGrid">
                                            <label> {phrase.location} </label>
                                            <span> {product.country} </span>
                                        </div> */}
                                    </div>

                                    <div className="pvDesc">
                                        <label>{phrase.description}</label>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    product.desc_proc.length > 200
                                                        ? product.desc_proc.substring(0, 200)
                                                        : product.desc_proc,
                                            }}
                                        ></p>
                                        {product.desc_proc.length > 200 ? (
                                            <a
                                                className="font-25"
                                                onClick={() => setProductDescPopup(true)}
                                            >
                                                {phrase.view_more}
                                            </a>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="scrollDown">
                                    <div className="ndCTA">
                                        <Button
                                            onClick={() =>
                                                document
                                                    .getElementById('productView')
                                                    .scrollIntoView({ behavior: 'smooth' })
                                            }
                                        >
                                            {phrase.scroll_to_bid}
                                        </Button>
                                        <div className="arrow">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3 mb-2"></div>
                                <div>
                                    <Button
                                        className="contactSeller"
                                        onClick={contactPopupOpen}
                                        disabled={user.isBuyer ? false : true}
                                    >
                                        <span className="material-icons">chat</span>
                                        <span> {phrase.contact_seller} </span>
                                    </Button>
                                </div>
                                <Popup
                                    open={contactPopup}
                                    handleClose={contactPopupClose}
                                    modaltitle={phrase.send_message}
                                    footer={
                                        <>
                                            <PrimaryButton
                                                label={phrase.send}
                                                onClick={contactSeller}
                                            />
                                            <SecondaryButton
                                                label={phrase.cancel}
                                                onClick={contactPopupClose}
                                            />
                                        </>
                                    }
                                >
                                    <div className="row text-left">
                                        <div className="col-md-2">
                                            <label>{phrase.title}</label>
                                        </div>
                                        <div className="col-md-8">
                                            <label>{product.title}</label>
                                        </div>
                                    </div>
                                    <div className="row text-left">
                                        <div className="col-md-2">
                                            <label>{phrase.message}</label>
                                        </div>
                                        <div className="col-md-8">
                                            <textarea
                                                className="form-control"
                                                id="contactSellerMsg"
                                                rows="4"
                                                placeholder={phrase.enter_your_message}
                                            ></textarea>
                                        </div>
                                    </div>
                                </Popup>
                            </div>
                        </div>
                        <div className="col-12 lotDetails" id="productView">
                            {product.currencyexist ? <CurrencyConverter product={product} /> : null}
                            <div className="lineItemMiscActions d-flex justify-content-end align-items-center">
                                <SecondaryButton
                                    btnSize="small"
                                    label={[
                                        <span className="material-icons">info</span>,
                                        phrase.bidding_instruction,
                                    ]}
                                    onClick={bidInstructionHandler}
                                />
                                {isAuthenticated ? (
                                    <>
                                        <SecondaryButton
                                            btnSize="small"
                                            label={[
                                                <span className="material-icons">
                                                    cloud_download
                                                </span>,
                                                phrase.download_manfiest,
                                            ]}
                                            onClick={downloadManifestFile}
                                        />
                                        {/* {product.isclosed >= 0 ? (
                                            <SecondaryButton
                                                btnSize="small"
                                                label={[
                                                    <span className="material-icons">
                                                        cloud_upload
                                                    </span>,
                                                    phrase.upload_bulk_bidding,
                                                ]}
                                                onClick={openCsvBidFile}
                                                disabled={user.isBuyer ? false : true}
                                            />
                                        ) : null} */}

                                        {/* <input
                                            type="file"
                                            id="bid_csv"
                                            accept=".xls,.xlsx"
                                            onChange={(e) => uploadBulkBidding(e)}
                                            hidden
                                        /> */}
                                    </>
                                ) : null}
                            </div>
                            <h2>{phrase.line_item_bidding}</h2>
                            <div className="customTabs">
                                <AppBar position="static">
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        aria-label="Line Item Auctions"
                                        indicatorColor="primary"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                    >
                                        <Tab
                                            label={
                                                phrase['products_description'] ||
                                                'Products Description'
                                            }
                                            {...a11yProps(0)}
                                        />
                                        <Tab
                                            label={phrase['condition'] || 'Condition'}
                                            {...a11yProps(1)}
                                        />
                                        <Tab label={phrase['faq'] || 'FAQ'} {...a11yProps(2)} />
                                        <Tab
                                            label={phrase['shipping'] || 'Shipping'}
                                            {...a11yProps(3)}
                                        />
                                        <Tab
                                            label={phrase['payment_note'] || 'Payment Note'}
                                            {...a11yProps(4)}
                                        />
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={value} index={0}>
                                    <div className="lotDataSort d-flex justify-content-between align-items-center flex-wrap">
                                        <h6 className="lotCount">
                                            {phrase.showing} {pageDescription} {phrase.of}{' '}
                                            {totalProductCnt} {phrase.lots}
                                        </h6>
                                        {isAuthenticated && isLineItemCommonSubmitMode ? (
                                            <div className="lineItemCommonSubmitCnt lineItemCommonSubmitTopCnt">
                                                <div className="lineItemCommonSubmitTopRow">
                                                    <h6 className="lotCount lineItemCommonSubmitInfo">
                                                        {formatPhraseTemplate(
                                                            phrase.lineitem_common_submit_info ||
                                                                'Bid on at least {minCount} products',
                                                            {
                                                                minCount: lineItemMinBidCount,
                                                            },
                                                        )}
                                                    </h6>
                                                    <PrimaryButton
                                                        onClick={submitLineItemBidsCommon}
                                                        disabled={
                                                            !user.isBuyer ||
                                                            product.market_status != 'open' ||
                                                            isAuctionNotStarted ||
                                                            isAuctionEnded ||
                                                            isSubmittingLineItemCommonBid
                                                        }
                                                    >
                                                        {isSubmittingLineItemCommonBid
                                                            ? phrase.lineitem_submitting ||
                                                              'Submitting...'
                                                            : phrase.submit}
                                                    </PrimaryButton>
                                                </div>
                                                {lineItemCommonError ? (
                                                    <p className="lineItemCommonSubmitError">
                                                        {lineItemCommonError}
                                                    </p>
                                                ) : null}
                                            </div>
                                        ) : null}
                                        <CustomSelect
                                            size="small"
                                            label={phrase['show_results'] || 'Show Results'}
                                            onChange={changePageLimit}
                                            value={pageLimit}
                                        >
                                            <MenuItem value={10}>10</MenuItem>
                                            <MenuItem value={25}>25</MenuItem>
                                            <MenuItem value={50}>50</MenuItem>
                                        </CustomSelect>
                                    </div>

                                    {lineItemsReady ? (
                                        <table className="table mobileTable laTable table-striped">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th scope="col">{phrase.sublot_id}</th>
                                                    {dynamicLineItemColumns.map((column) => (
                                                        <th scope="col" key={column.key}>
                                                            {column.label}
                                                        </th>
                                                    ))}
                                                    <th scope="col">{phrase.qty}</th>
                                                    {product.bidtype != 'sealed' ? (
                                                        <th scope="col">
                                                            {phrase.current_bid_per_unit ||
                                                                'Current Bid per Unit'}
                                                        </th>
                                                    ) : null}

                                                    <th scope="col">{phrase.action}</th>

                                                    {product.bidtype != 'sealed' ? (
                                                        <th scope="col">{phrase.status}</th>
                                                    ) : (
                                                        <th scope="col"></th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody className="mtInner">{lineItemsView}</tbody>
                                        </table>
                                    ) : (
                                        <Loader />
                                    )}
                                    {showPagination ? (
                                        <div className="d-flex justify-content-center mb-5">
                                            <Pagination
                                                count={totalPageCnt}
                                                onChange={changePageHandler}
                                            ></Pagination>
                                        </div>
                                    ) : null}
                                    {isAuthenticated ? (
                                        <div style={{ textAlign: 'center' }}>
                                            <PrimaryButton
                                                onClick={downloadManifestFile}
                                                width="40%"
                                            >
                                                <span
                                                    className="material-icons"
                                                    style={{ marginRight: '3px' }}
                                                >
                                                    cloud_download
                                                </span>{' '}
                                                {phrase.download_manfiest}
                                            </PrimaryButton>
                                        </div>
                                    ) : null}
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    {ReactHtmlParser(
                                        product?.desc_condition?.replace(/<br\s*\/?>/gi, ''),
                                    )}
                                </TabPanel>
                                <TabPanel
                                    value={value}
                                    index={2}
                                    html={product.faqContent}
                                ></TabPanel>
                                <TabPanel value={value} index={3}>
                                    {product.buyership == 1
                                        ? phrase.productview_1
                                        : product.shipping_service}
                                </TabPanel>
                                <TabPanel value={value} index={4}>
                                    {phrase.payment_note_details}
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="row">
                    <div className="col-12 assuranceCnt">
                        <div className="customContainer ">
                            <div className="col-lg-8 col-12">
                                <div className="assuranceCard d-flex justify-content-between">
                                    <span className="material-icons">verified</span>
                                    <div>
                                        <h2>{phrase.buy_with_confidence}</h2>
                                        <p>{phrase.productview_2}</p>
                                        <p>{phrase.productview_3}</p>
                                        <p>{phrase.productview_4}</p>
                                        <span className="leaf">
                                            <span className="material-icons">eco</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
            <Drawer
                className="rightDrawer"
                anchor={'right'}
                open={state['right']}
                onClose={toggleDrawer('right', false)}
            >
                <LineItemDetails data={state['data']} close={toggleDrawer('right', false)} />
            </Drawer>
            {/* /Bidding Instruction Popup*/}
            <Popup
                open={bidInstructionOpen}
                modaltitle={phrase.bidding_instruction}
                handleClose={bidInstructionClose}
                footer={<SecondaryButton label={phrase.close} onClick={bidInstructionClose} />}
            >
                <p dangerouslySetInnerHTML={{ __html: product.bidInstruction.for_english }} />
            </Popup>
            {/* Bulk Bidding Popup */}
            <Popup
                open={bulkBidPopupOpen}
                handleClose={bulkBidPopupClose}
                modaltitle={phrase.bid_confirmation}
                footer={
                    didBulkBid.current ? (
                        <PrimaryButton label={phrase.close} onClick={bulkBidPopupClose} />
                    ) : (
                        <>
                            {' '}
                            <PrimaryButton label={phrase.submit} onClick={submitBulkBidding} />
                            <SecondaryButton
                                label={phrase.cancel}
                                onClick={bulkBidPopupClose}
                            />{' '}
                        </>
                    )
                }
            >
                <div className="row ml-2 mr-2">
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>{phrase.brand}</th>
                                <th>{phrase.product_name}</th>
                                <th>{phrase.category}</th>
                                <th>{phrase.qty}</th>
                                <th>{phrase.amount}</th>
                                <th>{phrase.status}</th>
                            </tr>
                        </thead>
                        <tbody>{bulkBidTable}</tbody>
                    </table>
                </div>
            </Popup>

            {/* Long Product Description Modal*/}
            <Popup
                open={productDescPopup}
                modaltitle={phrase.description}
                handleClose={productDescClose}
                footer={<SecondaryButton label={phrase.close} onClick={productDescClose} />}
            >
                <div
                    style={{ textAlign: 'left' }}
                    dangerouslySetInnerHTML={{
                        __html: product.desc_proc,
                    }}
                ></div>
            </Popup>
            <BidHistory
                user={userRef.current}
                type={product.auctiontype}
                marketStatus={product.market_status}
            />

            {showDwBidStatus ? (
                <div className="dwBidStatus">
                    <a onClick={downloadBidStatus}>{phrase.download_bid_status}</a>
                </div>
            ) : null}
        </>
    )
}

export default LineItemAuction
